import { ConfigProvider } from 'antd';
import UserContext from 'src/admin/views/UserContext';
import { swrConfig } from 'src/lib/swr';
import { antdConfig } from 'src/lib/theme';
import { MainRouter } from 'src/router/router';
import { SWRConfig } from 'swr';

export function App() {
  return (
    <ConfigProvider {...antdConfig}>
      <SWRConfig value={swrConfig}>
        <UserContext>
          <MainRouter />
        </UserContext>
      </SWRConfig>
    </ConfigProvider>
  );
}
